import type { ReactElement } from 'react';
import { IconMail } from '@tabler/icons-react';
import { ButtonPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Cbutton } from '../Cbutton';
import { Cicon } from '../Cicon';
import { Ctext } from '../Ctext';
interface EmailSentAuthBodyProps {
    email: string;
    onRetry: () => void;
}
export function EmailSentAuthBody({ email, onRetry }: EmailSentAuthBodyProps): ReactElement {
    return (
      <div data-el="Cauthmodal/EmailSentAuthBody/Root" key="email-sent" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '24px',
            textAlign: 'center',
        }}>
        <Cicon icon={IconMail} size={64} color={ColorType.Accent}/>
        <Ctext size={24} weight={FontWeight.Bold} color={ColorType.White}>
          Check your email
        </Ctext>
        <Ctext size={16} weight={FontWeight.Regular} color={ColorType.White} opacity={0.8}>
          We&apos;ve sent a magic link to <span style={{ color: '#66FEC1', fontWeight: 600 }}>{email}</span>.
          Click it to log in.
        </Ctext>
        <Ctext size={14} weight={FontWeight.Regular} color={ColorType.White} opacity={0.6}>
          Didn&apos;t receive it? Check your spam folder or try again.
        </Ctext>
        <Cbutton preset={ButtonPreset.Secondary} onClick={onRetry} style={{ marginTop: '16px' }}>
          <Ctext size={16} weight={FontWeight.Medium} color={ColorType.White}>
            Try Another Email
          </Ctext>
        </Cbutton>
      </div>
    );
}
